import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './dialog';
import { Button } from './button';
import Icon from 'Components/Icon';
import { cn } from '@/lib/utils';

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: React.ReactNode;
  children?: React.ReactNode;
  confirmLabel?: React.ReactNode;
  cancelLabel?: React.ReactNode;
  /** Optional secondary action rendered between Cancel and Confirm (e.g. "Edit details"). */
  secondaryAction?: React.ReactNode;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
  className?: string;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  secondaryAction,
  onConfirm,
  isLoading = false,
  className,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={cn('tw tw:max-w-sm', className)}>
        <DialogHeader>
          <DialogTitle className="tw:mb-2">{title}</DialogTitle>
          {children && (
            <DialogDescription asChild>
              <div>{children}</div>
            </DialogDescription>
          )}
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            className="tw:text-muted-foreground tw:hover:text-muted-foreground"
          >
            {cancelLabel}
          </Button>
          {secondaryAction}
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading && (
              <Icon name="progress_activity" className="tw:animate-spin" />
            )}
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
